import { Box } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

const CenteredImageContainer = styled(Box)`
  text-align: center;
`;

export default CenteredImageContainer;
